import React from "react"
import Grid from '@material-ui/core/Grid';

/* importing custom modules */
import StaticExpander from '../components/Material-UI-Components/StaticExpander.js';
import Layout from '../components/layout'
import ContactForm from '../components/Custom Modules/ContactForm';
import SEO from "../components/seo"

/* importing json files */
import WhyCounsellingJSON from '../components/Page-Data/Why-Counselling.json';

/* importing images */
import Logo from '../images/WhyCounselling/logo.png';

const WhyCounselling = () => (
  <Layout>
    <SEO 
      title="Know Why Counselling is important for Career, Marriage, Adolescent etc ?" 
      description = "Know Why Counselling is important for Career, Marriage, Adolescent etc ? Pratiiti.com provides qualified counsellers at affordable rates."
      canonical={"https://www.pratiiti.in/why-counselling"} 
    />
    <div className="whyCounsellingBG">
    <Grid xs={12} md={6} sm={3}>
      <div className="logo">
        <img src={Logo} alt="why counselling logo"/>
      </div>
    </Grid>
      <StaticExpander
        data = {WhyCounsellingJSON}
      />
      <ContactForm/>
    </div>
  </Layout>
)

export default WhyCounselling
